<script setup lang="ts">
// Digits share one baseline and climb in size, so the glyph reads as a count
// building into the downbeat. The ramp stays shallow to keep all four legible.
const DIGIT_FONT_SIZES = [12.4, 13.8, 15.1, 16.5];
</script>

<template>
  <!-- Wide and short: four digits in a row, not the square of a typical toolbar
       icon. Callers set a width; the height follows the viewBox ratio. -->
  <svg
    viewBox="0 0 34 13"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <text
      x="17"
      y="12.5"
      text-anchor="middle"
      fill="currentColor"
    >
      <tspan
        v-for="(fontSize, index) in DIGIT_FONT_SIZES"
        :key="index"
        :font-size="fontSize"
      >{{ index + 1 }}</tspan>
    </text>
  </svg>
</template>

<style scoped>
/* The viewBox is sized from estimated digit advances, so let a font whose
   metrics run wide spill rather than clip. */
svg {
  overflow: visible;
}

text {
  font-family: inherit;
  font-weight: 700;
  letter-spacing: -0.6px;
}
</style>
